"use client";

import React from "react";

const HBetOddsCell = ({
  left,
  mid,
  right,
  leftTrend,
  midTrend,
  rightTrend,
  isEurope = false,
  isHandicap = false,
  className = "",
}) => {
  const getTrendColor = (trend, defaultColor = "") => {
    const isUp =
      trend === "up" || trend === "increased" || trend === 1 || trend === "1";
    const isDown =
      trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
    if (isUp) return "kbv-hbet-up";
    if (isDown) return "kbv-hbet-down";
    return defaultColor;
  };

  const renderTrendArrow = (trend) => {
    const isUp =
      trend === "up" || trend === "increased" || trend === 1 || trend === "1";
    const isDown =
      trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
    if (isUp)
      return (
        <span
          className="shrink-0 inline-block w-[10px] h-[10px] lu-odds-status--up ml-0.5"
          aria-hidden="true"
        />
      );
    if (isDown)
      return (
        <span
          className="shrink-0 inline-block w-[10px] h-[10px] lu-odds-status--down ml-0.5"
          aria-hidden="true"
        />
      );
    return null;
  };

  return (
    <span
      className={`${isEurope ? "md:text-[14px] " : ""}box-border kbv-hbet-odds-bg text-[12px] md:text-[16px] flex h-[34px] items-center justify-between rounded p-0 md:p-2 font-normal md:h-8 md:min-w-[120px] md:max-w-full md:px-1 ${className}`}
    >
      {/* Left Value */}
      <span
        className={`text-[12px] md:text-[16px] flex-1 text-center font-semibold flex items-center justify-center ${getTrendColor(leftTrend, isHandicap ? "kbv-hbet-up" : "kbv-hbet-txt-muted")}`}
      >
        {left ?? "-"}
        {renderTrendArrow(leftTrend)}
      </span>

      {/* Middle Value */}
      {isHandicap ? (
        <span className="kbv-hbet-txt-muted text-[12px] md:text-[16px] flex-1 text-center font-medium leading-tight">
          {mid ?? "-"}
        </span>
      ) : (
        <span
          className={`text-[12px] md:text-[16px] flex-1 text-center font-medium flex items-center justify-center ${getTrendColor(midTrend, "kbv-hbet-up")}`}
        >
          {mid ?? "-"}
          {renderTrendArrow(midTrend)}
        </span>
      )}

      {/* Right Value */}
      <span
        className={`text-[12px] md:text-[16px] flex-1 text-center font-semibold flex items-center justify-center ${getTrendColor(rightTrend, isHandicap ? "kbv-hbet-up" : "kbv-hbet-txt-muted")}`}
      >
        {right ?? "-"}
        {renderTrendArrow(rightTrend)}
      </span>
    </span>
  );
};

export default HBetOddsCell;
